import React from "react";
import styles from "./index.module.css"
export default class Title extends React.Component{

    render(){
        return (
            <div className={styles["titleDiv"]}>
                <h1>Taurus</h1>
            </div>
        )
    }
}